import { useScrollSmoother } from "../../hooks/useScrollSmoother";
import { prefersReducedMotion } from "../../lib/gsap";

export default function ScrollSmootherLayout({ children }) {
  const motionOk = !prefersReducedMotion();
  useScrollSmoother(motionOk);

  if (!motionOk) {
    return children;
  }

  return (
    <div id="smooth-wrapper">
      <div id="smooth-content">{children}</div>
    </div>
  );
}
